// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CLLL","questions":"styles_questions__3wlDs","footer":"styles_footer__2mewd"};